import { computed, Injectable, signal } from "@angular/core";
import { TechCoverTicketStatus } from "src/app/models/Enums";
import { TechCoverSoftwareRelease } from "src/app/models/TechCoverSoftwareRelease";
import { TechCoverTicket } from "src/app/models/TechCoverTicket";
import { TechCoverTicketCreate } from "src/app/models/TechCoverTicketCreate";
import { AuthService } from "src/app/services/auth.service";
import { CompanyService } from "src/app/services/company.service";
import { GlobalOverlayService } from "src/app/services/global-overlay.service";
import { TechCoverSoftwareReleaseService } from "src/app/services/tech-cover-software-release.service";
import { TechCoverTicketService } from "src/app/services/tech-cover-ticket.service";

@Injectable({
  providedIn: "root",
})
export class TechCoverTicketsDataService {
  constructor(
    private ticketService: TechCoverTicketService,
    private softwareService: TechCoverSoftwareReleaseService,
    private authService: AuthService,
    private companyService: CompanyService,
    private overlayService: GlobalOverlayService,
  ) {}

  private tickets = signal<TechCoverTicket[]>([]);
  private products = signal<TechCoverSoftwareRelease[]>([]);

  supportTickets = computed(() => this.tickets());
  supportedSoftware = computed(() => this.products());

  async loadDataAsync() {
    this.overlayService.show();
    try {
      const [tickets, softwareProducts] = await Promise.all([
        this.ticketService.getSupportTicketsAsync(this.companyService.selectedCompany.name),
        this.softwareService.getSoftwareReleases(this.companyService.selectedCompany.name),
      ]);
      this.tickets.set(tickets);
      this.products.set(softwareProducts);
    } finally {
      this.overlayService.close();
    }
  }

  async createTicketAsync(ticket: TechCoverTicketCreate): Promise<string> {
    const ticketNumber = await this.ticketService.createSupportTicketAsync(ticket);

    const createdTicket = new TechCoverTicket().deserialize({
      subject: ticket.title,
      description: ticket.description,
      createdDate: new Date(),
      status: TechCoverTicketStatus.New,
      productName: this.products().find((p) => p.softwareId === ticket.softwareId).softwareName,
      caseNumber: ticketNumber,
      createdBy: this.authService.user.email,
      salesforceId: "",
      closedDate: null,
    } as TechCoverTicket);

    this.tickets.update((t) => [...t, createdTicket]);

    return ticketNumber;
  }
}
